import Swal from "sweetalert2";

export const handleEditTour = (
  tourId,
  {
    toursData,
    MySwal,
    formRef,
    EditTourForm,
    tours,
    fetchData,
    cars,
    rentals,
    coupons,
    contact,
    drivers,
    tourBookings,
    employeeService,
    setCarsData,
    setRentalsData,
    setCouponsData,
    setTransfersData,
    setDriversData,
    setToursData,
    setTourBookingsData,
    setEmployeesData,
    setSeasonalPricing,
    setIsLoading,
    setError,
  }
) => {
  const tour = toursData.find((t) => t._id === tourId);
  if (!tour) {
    console.error("Tour not found:", tourId);
    return;
  }
  MySwal.fire({
    title: "Edit Tour",
    html: <EditTourForm ref={formRef} tour={tour} />,
    showCancelButton: true,
    confirmButtonText: "Update Tour",
    confirmButtonColor: "#1e3a8a",
    cancelButtonColor: "#d33",
    width: "800px",
    preConfirm: () => {
      const tourData = formRef.current?.getFormData();
      if (!tourData) {
        Swal.showValidationMessage(
          `Please fill all required fields correctly.`
        );
        return false;
      }
      return tourData;
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const tourData = result.value;
      const formData = new FormData();
      formData.append("name", tourData.name);
      formData.append("description", tourData.description);
      formData.append("duration", tourData.duration);
      formData.append("maxPersons", tourData.maxPersons);
      formData.append("vehicleType", tourData.vehicleType);
      formData.append("isActive", tourData.isActive);
      if (tourData.tourImage) {
        formData.append("tourImage", tourData.tourImage);
      }
      for (const vehicle in tourData.pricing) {
        for (const season in tourData.pricing[vehicle]) {
          formData.append(
            `pricing[${vehicle}][${season}]`,
            tourData.pricing[vehicle][season]
          );
        }
      }

      tourData.locations.forEach((loc) => formData.append("locations[]", loc));
      tourData.highlights.forEach((h) => formData.append("highlights[]", h));
      tours
        .update(tourId, formData)

        .then(() => {
          MySwal.fire({
            icon: "success",
            title: "Tour Updated!",
            text: "The tour has been updated successfully.",
            confirmButtonColor: "#1e3a8a",
            iconColor: "#10B981",
          });
          fetchData(); // Refresh tour data
        })
        .catch((error) => {
          console.error("Error updating tour:", error);
          const errorMsg =
            error.response?.data?.message ||
            error.message ||
            "An unknown error occurred.";
          MySwal.fire({
            icon: "error",
            title: "Update Failed",
            text: `Failed to update tour: ${errorMsg}`,
            confirmButtonColor: "#1e3a8a",
          });
        });
    }
  });
};
